module.exports = __webpack_public_path__ + "img/car-speed.f02ee4d4.png";